import { useNavigate, useParams } from 'react-router-dom';
import { useAppContext } from '../FirebaseAppContext';
import './DetailPages.css';

export default function RentalDetail() {
  const { rentalId } = useParams<{ rentalId: string }>();
  const navigate = useNavigate();
  const { state, rentalOperations } = useAppContext();
  const rental = state.rentals.find(r => r.id === rentalId);
  const car = rental ? state.cars.find(c => c.id === rental.carId) : undefined;
  const customer = rental ? state.customers.find(c => c.id === rental.customerId) : undefined;

  if (!rental) {
    return (
      <div className="detail-page">
        <div className="detail-card detail-list">
          <p>Rental not found</p>
          <button type="button" className="btn btn-secondary" onClick={() => navigate('/rentals')}>Back to Rentals</button>
        </div>
      </div>
    );
  }

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this rental?')) {
      try {
        await rentalOperations.delete(rental.id);
        navigate('/rentals');
      } catch (error) {
        alert('Failed to delete rental: ' + (error as Error).message);
      }
    }
  };

  const handleMarkReturned = async () => {
    const today = new Date().toISOString().split('T')[0];
    try {
      await rentalOperations.update(rental.id, { endDate: today });
    } catch (err) {
      alert('Failed to mark as returned: ' + (err as Error).message);
    }
  };

  return (
    <div className="detail-page">
      <div className="detail-header">
        <button type="button" className="btn btn-secondary" onClick={() => navigate('/rentals')}>← Back</button>
        <h1 className="detail-title">Rental Details</h1>
        <button type="button" className="btn btn-secondary" onClick={() => navigate(`/rentals/${rental.id}/edit`)}>Edit</button>
        {!rental.endDate && (
          <button type="button" className="btn btn-primary" onClick={handleMarkReturned}>
            Mark Returned Today
          </button>
        )}
        <button type="button" className="btn btn-primary" onClick={handleDelete}>
          Delete
        </button>
      </div>

      <div className="detail-card detail-list">
        <div className="detail-item"><span className="detail-item-label">Customer</span><span className="detail-item-value">{customer?.name || 'Unknown'}</span></div>
        <div className="detail-item"><span className="detail-item-label">Car</span><span className="detail-item-value">{car ? `${car.year} ${car.make} ${car.model} (${car.licensePlate})` : 'Unknown'}</span></div>
        <div className="detail-item"><span className="detail-item-label">Start Date</span><span className="detail-item-value">{new Date(rental.startDate).toLocaleDateString()}</span></div>
        <div className="detail-item"><span className="detail-item-label">End Date</span><span className="detail-item-value">{rental.endDate ? new Date(rental.endDate).toLocaleDateString() : 'Open-ended'}</span></div>
        {rental.address && <div className="detail-item"><span className="detail-item-label">Address</span><span className="detail-item-value">{rental.address}</span></div>}
        {rental.paymentMethod && <div className="detail-item"><span className="detail-item-label">Payment Method</span><span className="detail-item-value">{rental.paymentMethod}</span></div>}
        {rental.cardLastFour && <div className="detail-item"><span className="detail-item-label">Card Last 4</span><span className="detail-item-value">{rental.cardLastFour}</span></div>}
        {rental.deposit && <div className="detail-item"><span className="detail-item-label">Deposit</span><span className="detail-item-value">${rental.deposit.toFixed(2)}</span></div>}
        {rental.dailyRate && <div className="detail-item"><span className="detail-item-label">Daily Rate</span><span className="detail-item-value">${rental.dailyRate.toFixed(2)}</span></div>}
        {rental.totalCost && <div className="detail-item"><span className="detail-item-label">Total Cost</span><span className="detail-item-value">${rental.totalCost.toFixed(2)}</span></div>}
        {rental.amountDue && <div className="detail-item"><span className="detail-item-label">Amount Due</span><span className="detail-item-value">${rental.amountDue.toFixed(2)}</span></div>}
      </div>
    </div>
  );
}

